import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-location';

import pageCatalog from 'pages/pageCatalog';
import './styles.css';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const gameChallenge = require('common/assets/magicMovie/game-challenge-01.png');

export const MagicMovieChallenge: React.FC = () => {
  const { t } = useTranslation(['magicMovie']);
  const navigate = useNavigate();

  return (
    <div id="game" className="gameContainer challenge" data-test-id="magicMovieChallengeRoot">
      <div className="limitLine gameContentContainer">
        <div style={{ flex: 2 }}>
          <h1 style={{ marginBottom: '20px' }}>
            <div className="challengeImage" style={{ backgroundImage: 'url(' + gameChallenge + ')' }}></div>
            {t('challenge.title')}
          </h1>
          <p className="blue" style={{ marginBottom: '20px', marginTop: 0 }}>
            {t('challenge.demonstration')}
          </p>
          <p className="blue" style={{ marginBottom: '40px', marginTop: 0 }}>
            {t('challenge.keepingUp')}
          </p>
          <button
            className="customButton"
            style={{
              maxWidth: '400px',
              fontSize: '24px',
              padding: '20px',
              borderRadius: '4px',
              background: 'orange',
              color: '#16191F',
            }}
            onClick={() => {
              navigate({ to: pageCatalog['MagicMovieHowToPlay'].route });
            }}
            data-analytics-type="eventDetail"
            data-analytics="howserChallengeContinueButton"
            data-test-id="magicMovieChallengeContinueButton"
          >
            {t('challenge.continue')}
          </button>
        </div>
      </div>
    </div>
  );
};
